export const TIER_TITLES = {
  tier1: 'individual',
  tier2: 'plans_business',
  tier3: 'enterprise',
}
